import React, { useContext, useEffect, useRef, useState } from "react";
import ThumbnailContext from "../../../../context/studyviewer/ThumbnailContext";
import Thumbnail from "./Thumbnail";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import { isMobile } from "react-device-detect";
import themeContext from "../../../../context/theme/ThemeContext";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import ViewportContext from "../../../../context/studyviewer/ViewportContext";
import ChildStudyThumbnailList from "./ChildStudyThumbnailList";

const ThumbnailList = ({
  patientName,
  patientId,
  studyData,
  priorStudyData,
  priors,
}) => {
  const {
    impressionHoveredStudyId,
    setImpressionHoveredStudyId,
    setSeriesHovered,
  } = useContext(ThumbnailContext);
  const thumbnailRef = useRef(null);
  const { setSeriesMenu } = useContext(studyReportContext);
  const { theme, themeName ,getScrollBarStyleForTheme} = useContext(themeContext);
  const { setShowImpressions, showImpressions, imageLoadedOnViewport } =
    useContext(ViewportContext);
  const { getConsistentDateFormat } = useContext(studyReportContext);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        thumbnailRef.current &&
        !thumbnailRef.current.contains(event.target) &&
        isMobile
      ) {
        if (event.clientY >= 50) setSeriesMenu(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  let count = 0;
  let timer;

  const onHovered = (e, studyId) => {
    e.stopPropagation();
    timer = setTimeout(() => {
      setImpressionHoveredStudyId(studyId);
      setSeriesHovered(true);
    }, 300);
  };

  const onHoveredOut = (e) => {
    e.stopPropagation();
    clearTimeout(timer);
    setImpressionHoveredStudyId(0);
    setSeriesHovered(false);
  };
  
  return (
    <div ref={thumbnailRef} className="thumbnail-list">
      <div className="thumbnail-list-patient-details">
        <div className="thumbnail-list-patient-name">{patientName}</div>
        <div className="thumbnail-list-patient-id" style={{color: themeName === "light" ? "black" : ""}}>ID {patientId}</div>
      </div>

      {/* Thumbnail List */}
      {priors ? (
        <>
          {/* {console.log("I am inside priors thumbnail List")} */}
          <div className="thumbnail-list-studies-impression">
            <span className="thumbnail-list-studies">Studies</span>
            <span
              className={`thumnail-list-impressions ${
                showImpressions ? "thumnail-list-impressions-active" : ""
              }`}
              onClick={() => setShowImpressions(!showImpressions)}
            >
              Impressions
            </span>
          </div>
          <div
            className={"thumbnail-list-container "+getScrollBarStyleForTheme(themeName,"common-modal-scroll")}
          >
            <div className="h100 w100">
              {priorStudyData?.map((studyData, studyIndex) => {
                // console.log(studyData);
                if (studyIndex === 0) {
                  return (
                    <React.Fragment key={studyIndex}>
                      <div className="thumbnail-list-sticky-header">
                        <span>
                          {getConsistentDateFormat(
                            studyData.uploadDateDisplay
                          ).slice(0, 9)}
                        </span>
                        <span style={{ paddingRight: "10px" }}>
                          {getConsistentDateFormat(
                            studyData.uploadDateDisplay
                          ).slice(10)}
                        </span>
                      </div>

                      {studyData.stacks?.map((stack, index) => {
                        return (
                          <div
                            id={`thumbnail_container_${stack.studyId}`}
                            className={`${
                              stack.studyId == impressionHoveredStudyId &&
                              showImpressions
                                ? "highlight-thumbnail"
                                : ""
                            }`}
                            key={count}
                            style={{ paddingTop: "20px" }}
                            onMouseEnter={(e) => onHovered(e, stack.studyId)}
                            onMouseLeave={onHoveredOut}
                          >
                            <Thumbnail
                              stack={stack}
                              index={count++}
                              originalStack={studyData.originalStacks[index]}
                              heatmapStack={studyData.heatmapStacks[index]}
                              outlineStack={studyData.outlineStacks[index]}
                              isPriors={studyIndex === 0 ? false : true}
                              studyIndex={studyIndex}
                              priors={priors}
                            />
                            <br></br>
                          </div>
                        );
                      })}
                    </React.Fragment>
                  );
                } else {
                  if (studyIndex > 1) {
                    count += priorStudyData[studyIndex - 1].stacks.length;
                  }
                  return (
                    <ChildStudyThumbnailList
                      studyData={studyData}
                      startIndex={count}
                      studyIndex={studyIndex}
                      priors={priors}
                    />
                  );
                }
              })}
            </div>
          </div>
        </>
      ) : (
        <>
          <div className={"thumbnail-list-container "+getScrollBarStyleForTheme(themeName,"common-modal-scroll")}>
            <div className="thumbnail-list-sticky-header">
              <span>
                {getConsistentDateFormat(studyData.uploadDateDisplay).slice(
                  0,
                  9
                )}
              </span>
              <span style={{ paddingRight: "10px" }}>
                {getConsistentDateFormat(studyData.uploadDateDisplay).slice(10)}
              </span>
            </div>
            {studyData.stacks?.map((stack, index) => {
              if (isMobile) {
                if (index == 0) {
                  return (
                    <div key={index} style={{ paddingTop: "20px" }}>
                      <Thumbnail
                        stack={stack}
                        index={index}
                        originalStack={studyData.originalStacks[index]}
                        heatmapStack={studyData.heatmapStacks[index]}
                        outlineStack={studyData.outlineStacks[index]}
                        isPriors={false}
                      />
                    </div>
                  );
                }
              } else {
                return (
                  <div key={index} style={{ paddingTop: "20px" }}>
                    <Thumbnail
                      stack={stack}
                      index={index}
                      originalStack={studyData.originalStacks[index]}
                      heatmapStack={studyData.heatmapStacks[index]}
                      outlineStack={studyData.outlineStacks[index]}
                      isPriors={false}
                    />
                  </div>
                );
              }
            })}
            {imageLoadedOnViewport &&
              isMobile &&
              studyData.stacks?.map((stack, index) => {
                if (index !== 0) {
                  return (
                    <div key={index} style={{ paddingTop: "20px" }}>
                      <Thumbnail
                        stack={stack}
                        index={index}
                        originalStack={studyData.originalStacks[index]}
                        heatmapStack={studyData.heatmapStacks[index]}
                        outlineStack={studyData.outlineStacks[index]}
                        isPriors={false}
                      />
                    </div>
                  );
                }
              })}
          </div>
        </>
      )}
    </div>
  );
};

export default ThumbnailList;
